import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.timers.js";
export default {
  name: 'TokensFalling',
  components: {
    // ButtonBasic,
    // ToggleComponent,
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.soundEffects();
            console.log('<<<<<<<<< ShowXRated mounted >>>>>>>>>');
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    soundEffects: function soundEffects() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var video, audio;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              video = document.getElementById('myVideo');
              video.playbackRate = 8.5; // 1.5 times the normal speed
              //    play sound effects until video stops
              audio = document.getElementById('myAudio');
              audio.volume = 0.5; // 50% volume
              setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return _this2.playTokenFallingSound();
                    case 2:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              })), 100);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    playTokenFallingSound: function playTokenFallingSound() {
      return new Promise(function (resolve) {
        var myAudio = document.getElementById("myAudio");
        myAudio.src = 'assets/audio/coinsdrop.mp3';
        myAudio.play();
        myAudio.onended = function () {
          resolve();
        };
      });
    }
  },
  setup: function setup() {},
  data: function data() {
    return {
      AudioFileToPlay: 'assets/audio/coinsdrop.mp3'
    };
  }
};